export enum AdditionalAssistEnum {
  dentalAssists = 'Asistencia Dental',
  petAssists = 'Asistencia Mascotas',
}
